import { Stack } from '@mantine/core';
import { trackEvent } from '@repo/common/analytics';
import { useMount } from 'ahooks';
import { useAuthUser } from '../../api';
import { AiTokenUsageOverviewTabController } from '../../features/Overview/AiTokenUsageOverviewTabController';

export function AiTokenUsageSettings() {
	const { user, workspace } = useAuthUser();

	useMount(() => {
		trackEvent('ai_token_usage_settings/view', {}, user, workspace);
	});

	return (
		<Stack>
			<AiTokenUsageOverviewTabController />
		</Stack>
	);
}
